import { render, staticRenderFns } from "./project_discuss.vue?vue&type=template&id=ac201206&scoped=true"
import script from "./project_discuss.vue?vue&type=script&lang=js"
export * from "./project_discuss.vue?vue&type=script&lang=js"
import style0 from "./project_discuss.vue?vue&type=style&index=0&id=ac201206&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac201206",
  null
  
)

export default component.exports